export enum CaseWorkflowNode {
    PatientInfo = 1,
    TreatmentType,
}
